import styled from 'styled-components';

interface ItemProps {
  readonly xmargin?: string;
}

export const InputCheckboxWrapper = styled.label<ItemProps>`
  display: inline-block;
  margin: ${props => props.xmargin};
  & input {
    display: none;
  }
  & input:checked + span {
    background-color: var(--PrimaryBlue);
  }
  & input:checked + span svg {
    opacity: 1;
  }
`;

export const InputCheckboxSkin = styled.span`
  background-color: var(--BackgroundGrey);
  align-items: center;
  border: 1px solid #e6e7e9;
  border-radius: 5px;
  display: flex;
  height: 20px;
  justify-content: center;
  width: 20px;
  & svg {
    font-size: 14px;
    opacity: 0;
  }
`;
